module.exports = __webpack_public_path__ + "img/04-xjtu-wneu-polimi.71180d8c.png";